import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';

interface  myData{
  message: string,
  success: boolean
}

interface isLoggedIn{
  status: boolean
}

interface logoutStatus{
  success: boolean
}

interface user{
    id: number;
    username: string;
    ataRoleId: number;
    zoneId: number;
    regionId: number;
    languageId: number;
}

interface Permissions {
  id: number;
  permissionIds: string;
}

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private  http: HttpClient) { }

  getSomeData(){
    return this.http.get<myData>('/api/data');
  }

  isLoggedIn(){
    return this.http.get<isLoggedIn>('/api/LoggedInUser');
  }

  logout(){
    return this.http.get<logoutStatus>('/api/logout');
  }

  getSession(){
      return this.http.get<user>('/api/getSession');
  }

  getUserPermissionList() {
    return this.http.get<Permissions>('/api/user/userPermissions');
  }
}
